import React from "react";
import ServiceCard from "./ServiceCard";

import HealthImg from "../../assets/images/health.jpg";
import LegalImg from "../../assets/images/legal.jpg";
import EducationImg from "../../assets/images/education.jpg";
import JobsImg from "../../assets/images/job.jpg";
import BusinessImg from "../../assets/images/business.jpg";
import FinanceImg from "../../assets/images/finance.jpg";
import HousingImg from "../../assets/images/housing.jpg";
import FamilyImg from "../../assets/images/family.jpg";
import FashionImg from "../../assets/images/fashion.jpg";
import CommunityImg from "../../assets/images/community.jpg";

const ServicesSection = () => {
  const services = [
    {
      imageSrc: HealthImg,
      title: "Health",
      subheadline: "Connect with trusted health & wellness support worldwide.",
      link: "/help/health",
    },
    {
      imageSrc: LegalImg,
      title: "Legal",
      subheadline: "Access trusted legal help from workplace to family law.",
      link: "/help/legal",
    },
    {
      imageSrc: EducationImg,
      title: "Education",
      subheadline: "Find learning, training, and scholarships made for women.",
      link: "/help/education",
    },
    {
      imageSrc: JobsImg,
      title: "Jobs",
      subheadline:
        "Work, return to work, or upgrade your career with women-first job tools.",
      link: "/help/jobs",
    },
    {
      imageSrc: BusinessImg,
      title: "Business",
      subheadline:
        "Support for women-led startups, freelancers, and entrepreneurs.",
      link: "/help/business",
    },
    {
      imageSrc: FinanceImg,
      title: "Finance",
      subheadline: "Tools and resources for financial independence and growth.",
      link: "/help/finance",
    },
    {
      imageSrc: HousingImg,
      title: "Housing",
      subheadline: "Find safe and secure housing options tailored for women.",
      link: "/help/housing",
    },
    {
      imageSrc: FamilyImg,
      title: "Family",
      subheadline:
        "Support for every stage of family life — from childcare to elder care.",
      link: "/help/family",
    },
    {
      imageSrc: FashionImg,
      title: "Fashion",
      subheadline:
        "Celebrate identity with women-led fashion and creative empowerment.",
      link: "/help/fashion",
    },
    {
      imageSrc: CommunityImg,
      title: "Community",
      subheadline:
        "Connect through events, mentorship, and women’s support networks.",
      link: "/help/community",
    },
  ];

  return (
    <section className="py-16 bg-main-light px-6 sm:px-12 lg:px-16">
      <div className="text-center mb-12">
        <h2 className="text-4xl sm:text-5xl font-barlow font-extrabold text-main-dark mb-4">
          Explore Our Help Portal
        </h2>
        <p className="text-xl font-aeonik text-text-color">
          Choose the type of help you need — and we’ll match you to support.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-screen-xl mx-auto">
        {services.map((service, idx) => (
          <ServiceCard key={idx} {...service} />
        ))}
      </div>
    </section>
  );
};

export default ServicesSection;
